module.exports = __webpack_public_path__ + "static/img/user-task.90bd34cf.svg";